import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const getHeaders = () => {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    const headers = {};
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
};

export async function getMetaConfig() {
    try {
        const response = await axios.get(`${API_BASE}/api/meta-leads/config`, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to fetch Meta Lead Ads config');
    }
}

export async function getMetaPagesForms(pageId, sessionId) {
    try {
        const response = await axios.get(`${API_BASE}/api/meta-leads/pages/${pageId}/forms?sessionId=${sessionId}`, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to fetch lead forms for page');
    }
}

export async function connectMetaLeads(payload) {
    try {
        const response = await axios.post(`${API_BASE}/api/meta-leads/connect`, payload, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to connect Meta Lead Ads');
    }
}

export async function getMetaIntegrationStatus() {
    try {
        const response = await axios.get(`${API_BASE}/api/meta-leads`, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to fetch integration status');
    }
}

export async function disconnectMetaLeads(id) {
    try {
        const response = await axios.delete(`${API_BASE}/api/meta-leads/${id}`, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to disconnect Meta Lead Ads');
    }
}

export async function syncMetaLeads(payload) {
    try {
        const response = await axios.post(`${API_BASE}/api/meta-leads/sync`, payload, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to sync Meta Lead Ads');
    }
}

export async function updateMetaAssignment(id, payload) {
    try {
        const response = await axios.patch(`${API_BASE}/api/meta-leads/${id}/assignment`, payload, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to update lead assignment pool');
    }
}
